/* =============================================
   COLLI THEME — Product Detail Page JS
   ============================================= */

(function initProductPage() {
  // ── SIZE SELECTION ──
  let selectedSize = null;
  const sizeBtns = document.querySelectorAll('.size-btn');
  const addBtn = document.querySelector('.add-to-cart-btn');

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedSize = btn.dataset.size;
      // FIX: Update the variant ID on the add-to-cart button
      if (addBtn) addBtn.dataset.variantId = btn.dataset.variantId;
    });
  });

  // ── ADD TO CART ──
  const sizeError = document.querySelector('.size-error');
  if (addBtn) {
    addBtn.addEventListener('click', async () => {
      if (sizeBtns.length > 0 && !selectedSize) {
        if (sizeError) { sizeError.style.display = 'block'; setTimeout(() => sizeError.style.display = 'none', 3000); }
        return;
      }
      const variantId = addBtn.dataset.variantId || document.querySelector('[data-variant-id]')?.dataset.variantId;
      if (!variantId) return;
      addBtn.disabled = true;
      addBtn.innerHTML = '<span>Wird hinzugefügt…</span>';
      await window.colliCart?.addItem(variantId);
      addBtn.disabled = false;
      addBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span>In den Warenkorb</span>`;
    });
  }

  // ── RELATED PRODUCTS HORIZONTAL SCROLL ──
  (function initRelatedScroll() {
    const section = document.querySelector('.related-scroll-section');
    const slider  = document.querySelector('.related-slider');
    if (!section || !slider) return;

    function update() {
      const rect  = section.getBoundingClientRect();
      const total = section.offsetHeight - window.innerHeight;
      const progress = Math.max(0, Math.min(1, -rect.top / total));
      const maxX = slider.scrollWidth - window.innerWidth;
      slider.style.transform = `translateX(${-progress * maxX * 0.8}px)`;
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();
})();
